module.exports = __webpack_public_path__ + "img/hiw-mobile.ea8faedf.jpg";